import { t } from "i18next";
import * as z from "zod";

import { PRODUCT_CATEGORIES } from "@/features/shared/api/enums";

/**
 * Schéma du formulaire d'un code produit
 * (`POST /ProductCodes/add` / `PUT /ProductCodes/{id}`, guide §6.4).
 *
 * Factory (règle projet) : créé via `createProductCodeSchema()` et
 * mémoïsé au niveau composant sur la langue courante.
 */
export const createProductCodeSchema = () =>
  z.object({
    code: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    label: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    category: z.enum(PRODUCT_CATEGORIES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    isActive: z.boolean(),
  });

export type ProductCodeFormValues = z.infer<
  ReturnType<typeof createProductCodeSchema>
>;
